// #253 — company-level feature gate for Brandon's capacity-aware / recommendation
// / geo feature class. The features depend on FileMaker fields — `capacity_*` caps,
// `StopDistance` + the 🚗 mileage indicator, `Candidate_Stores` / `capacity_stores`,
// `google_lat`/`google_lon` geocoding, `LaborAttributes`, `Scheduling_Hold_*` — that
// were added to the KI layouts only.
//
// SCG (Surfaces Construction Group) lives on a SEPARATE FileMaker server whose
// Recruiter/ActiveQueue layouts do NOT yet carry those fields (the #248/#195
// reconciliation work found SCG's candidate layout missing 47 of KI's fields —
// every capacity/geo field among them; see GitHub #253/#254). So for an SCG job or
// installer those values arrive empty/absent and every capacity-aware feature
// renders empty or malformed (caps fall back to unconstrained, geo is unmeasurable,
// recommendation rows are bad). Until SCG's FileMaker schema + data reach KI parity,
// gate the whole feature class OFF by company.
//
// Returns true when the capacity-aware features should be ACTIVE for `companyCode`.
// FAIL-SAFE: only an explicitly disabled company ("SCG") turns the features off; an
// unknown/blank companyCode keeps the KI (enabled) behavior so nothing breaks for the
// default company. Routing EVERY capacity/recommendation/geo gate through this one
// predicate makes re-enabling SCG a one-line flip (remove it from the set below) once
// their FileMaker fields land.

export const CAPACITY_AWARE_DISABLED_COMPANIES = ["SCG"];

export function isCapacityAwareEnabled(companyCode) {
  if (!companyCode) return true; // unknown/blank → default to KI (enabled) behavior
  return !CAPACITY_AWARE_DISABLED_COMPANIES.includes(String(companyCode).toUpperCase());
}
